import { render } from "./JobEditor.vue?vue&type=template&id=2a489e7b&scoped=true"
import script from "./JobEditor.vue?vue&type=script&lang=js"
export * from "./JobEditor.vue?vue&type=script&lang=js"

import "./JobEditor.vue?vue&type=style&index=0&id=2a489e7b&scoped=true&lang=css"
import "./JobEditor.vue?vue&type=style&index=1&id=2a489e7b&lang=css"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a489e7b"]])

export default __exports__